import React from 'react';
import AddSwiftBeneficiary from './international/swift';
import AddSwiftUnknownBeneficiary from './international/swift-unknown';
import AddIbanBeneficiary from './international/iban';
import { useBeneficiaryStore } from '../../../../../store';
import AddUsdLocalBeneficiary from './local/usd-local';
import { PaymentMethodEnum } from '../../../../../models/beneficiary.model';

interface BeneficiaryBankAccountDetailsProps {
  addBeneficiary: () => void;
  prev: () => void;
  loading: boolean;
  caller: string; // Ensure caller is included in the props
}

const BeneficiaryBankAccountDetails: React.FC<
  BeneficiaryBankAccountDetailsProps
> = ({ addBeneficiary, prev, loading, caller }) => {
  const { beneficiaryPayload } = useBeneficiaryStore();

  return (
    <div>
      {(beneficiaryPayload.paymentMethod === 'SWIFT' ||
        beneficiaryPayload.paymentType === PaymentMethodEnum.SWIFT) && (
        <AddSwiftBeneficiary
          addBeneficiary={addBeneficiary}
          prev={prev}
          loading={loading}
          caller={caller} // Pass caller to the child component
        />
      )}
      {(beneficiaryPayload.paymentMethod === 'SWIFTUnknown' ||
        beneficiaryPayload.paymentType === PaymentMethodEnum.SWIFTUNKNOWN) && (
        <AddSwiftUnknownBeneficiary
          addBeneficiary={addBeneficiary}
          prev={prev}
          loading={loading}
          caller={caller}
        />
      )}
      {(beneficiaryPayload.paymentMethod === 'IBAN' ||
        beneficiaryPayload.paymentType === PaymentMethodEnum.IBAN) && (
        <AddIbanBeneficiary
          addBeneficiary={addBeneficiary}
          prev={prev}
          loading={loading}
          caller={caller}
        />
      )}
      {(beneficiaryPayload.paymentMethod === 'USDLocal' ||
        beneficiaryPayload.paymentType === PaymentMethodEnum.USDLocal) && (
        <AddUsdLocalBeneficiary
          addBeneficiary={addBeneficiary}
          prev={prev}
          loading={loading}
          caller={caller}
        />
      )}
    </div>
  );
};

export default BeneficiaryBankAccountDetails;
